import React, { createContext, useReducer, useContext, useEffect } from "react";

const INITIAL_STATE = {
  city: undefined,
  dates: [],
  options: {
    adult: undefined,
    children: undefined,
    room: undefined,
  },
};

export const SearchContext = createContext(INITIAL_STATE);

const SearchReducer = (state, action) => {
  switch (action.type) {
    case "NEW_SEARCH":
      return action.payload;
    case "RESET_SEARCH":
      return INITIAL_STATE;
    case "SET_DATES":
      return {
        ...state,
        dates: action.payload,
      };
    default:
      return state;
  }
};

const loadState = () => {
  if (typeof window === "undefined") {
    return INITIAL_STATE;
  }
  try {
    const serializedState = localStorage.getItem("searchState");
    if (serializedState === null) {
      return INITIAL_STATE;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return INITIAL_STATE;
  }
};

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("searchState", serializedState);
  } catch {
    // Ignore write errors
  }
};

export const SearchContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(SearchReducer, INITIAL_STATE);

  return (
    <SearchContext.Provider
      value={{
        city: state.city,
        dates: state.dates,
        options: state.options,
        dispatch,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error("useSearch must be used within a SearchContextProvider");
  }
  return context;
};

export const setCity = (city) => ({
  type: "SET_CITY",
  payload: city,
});

export const setDates = (dates) => ({
  type: "SET_DATES",
  payload: dates,
});

export const setOptions = (options) => ({
  type: "SET_OPTIONS",
  payload: options,
});

export const newSearch = (searchState) => ({
  type: "NEW_SEARCH",
  payload: searchState,
});

export const resetSearch = () => ({
  type: "RESET_SEARCH",
});

/*
import React, { createContext, useReducer, useContext, useCallback } from 'react';

// Initial state
const INITIAL_STATE = {
  city: undefined,
  dates: [null, null],
  options: {
    adult: 1,
    children: 0,
    room: 1,
  },
};

// Create context
const SearchContext = createContext(undefined);

// Reducer function
const SearchReducer = (state, action) => {
  switch (action.type) {
    case 'SET_CITY':
      return { ...state, city: action.payload };
    case 'SET_DATES':
      return { ...state, dates: action.payload };
    case 'SET_OPTIONS':
      return { ...state, options: { ...state.options, ...action.payload } };
    case 'NEW_SEARCH':
      return action.payload;
    case 'RESET_SEARCH':
      return INITIAL_STATE;
    default:
      return state;
  }
};

// Load state from localStorage
const loadState = () => {
  try {
    const serializedState = localStorage.getItem('searchState');
    if (serializedState === null) {
      return INITIAL_STATE;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return INITIAL_STATE;
  }
};

// Save state to localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('searchState', serializedState);
  } catch {
    // Ignore write errors
  }
};

// Provider component
export const SearchContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(SearchReducer, loadState());

  // Save state to localStorage whenever it changes
  React.useEffect(() => {
    saveState(state);
  }, [state]);

  const memoizedDispatch = useCallback(dispatch, []);

  return (
    <SearchContext.Provider value={{ state, dispatch: memoizedDispatch }}>
      {children}
    </SearchContext.Provider>
  );
};


*/
